import React from 'react'
import TableLayout from '../../layouts/pagesLayouts/TableLayout'
import { Button, Typography } from '@material-tailwind/react'
import { useTranslation } from 'react-i18next'
import PageLayout from '../../layouts/pagesLayouts/PageLayout'

const ViewNotFound = ({
    codeText,
    text,
    refetch
}: {
    codeText?: string,
    text?: string,
    refetch?: (_: any) => void
}) => {

    // text
    {/* {t('tables.error_page_not_found')} */ }
    {/* {t('tables.error_on_roles_view')} */ }

    const { t } = useTranslation()

    return (
        <PageLayout>
            <div className=' tab:max-w-[75vw] lap2:max-w-[40vw] mx-auto flex-col items-center my-[16vw]'>
                <TableLayout>
                    {/* <div className="flex flex-col items-center gap-[40px] my-[40px]">
                                        <Typography variant='lead' className='des:text-[20px] font-medium text-center '>
                                            {t('tables.error_on_loading')}
                                        </Typography>
                                        <Button onClick={refetch} color='black'>
                                            {t('reload')}
                                        </Button>
                                    </div> */}
                    <div className="flex flex-col items-center gap-[20px] py-[24px]">
                        {
                            codeText &&
                            <Typography variant='lead' className='des:text-[80px] text-gray-300 font-medium text-center'>
                                {codeText}
                            </Typography>
                        }
                        {
                            text ?
                                <Typography variant='paragraph' className='des:text-[20px] font-medium text-center'>
                                    {t(text)}
                                </Typography>
                                :
                                <Typography variant='paragraph' className='des:text-[20px] font-medium text-center'>
                                    {t('tables.error_on_loading')}
                                </Typography>
                        }
                        {
                            refetch &&
                            <Button onClick={refetch} color='black'>
                                {t('reload')}
                            </Button>
                        }
                    </div>
                </TableLayout>
            </div>
        </PageLayout>
    )
}

export default ViewNotFound